import { readonly, ref } from 'vue';

type ElixirConfigType = {
  apiUrl: string;
  backendStaticUrl: string;
  client_id: string;
  company_id: string;
  room_id: string;
  socketUrl: string;
};

function makeElixirConfig() {
  const config = ref<ElixirConfigType | null>(null);
  const readOnlyElixirConfig = readonly(config);

  return {
    get enabled() {
      return Boolean(config.value);
    },
    get config() {
      return readOnlyElixirConfig.value;
    },
    setElixirConfig: (value: ElixirConfigType) => {
      config.value = value;
      return value;
    }
  };
}

export const elixirConfig = makeElixirConfig();
